import { SmartAppItem } from './smart-app-item'

export class SmartAppUrlItem extends SmartAppItem {
  public url: string

  constructor(model: SmartAppItem) {
    super(model)
    this.url = model.url
  }
}
